import React from 'react'
import cx from 'classnames'

import {
  ModalFormRow,
  CheckboxGroup
} from '../modal-form/modal-form'

import collectionChangeHandler from '../../helpers/collection-change-handler'

const ServicesSelector = ({
  commonServices,
  otherServices,
  attribute,
  completedServices,
  workOrderId,
  ...rest
}) => (
  <div className='services-selector' {...rest}>
    <ModalFormRow>
      <CheckboxGroup title={<span>Services <span style={{ color: 'red' }}>*</span></span>}>
        {
          commonServices.map((service, index) => {
            const disabled = completedServices && completedServices.indexOf(service.id) >= 0
            return (
              <label htmlFor={service.id} key={service.id} className={cx({ disabled })}>
                <input
                  type='checkbox'
                  value={service.id}
                  id={service.id}
                  checked={(attribute.value && attribute.value.indexOf(service.id) >= 0)}
                  disabled={disabled}
                  onChange={collectionChangeHandler(attribute)}
                />
                <span className='indicator' />
                {service.name}
              </label>
            )
          })
        }
      </CheckboxGroup>
    </ModalFormRow>
    <ModalFormRow>
      <CheckboxGroup title=' '>
        {
          otherServices.map((service, index) => {
            const disabled = completedServices && completedServices.indexOf(service.id) >= 0
            return (
              <label htmlFor={service.id} key={service.id} className={cx({ disabled })}>
                <input
                  type='checkbox'
                  value={service.id}
                  id={service.id}
                  checked={(attribute.value && attribute.value.indexOf(service.id) >= 0)}
                  disabled={disabled}
                  onChange={collectionChangeHandler(attribute)}
                />
                <span className='indicator' />
                {service.name}
              </label>
            )
          })
        }
      </CheckboxGroup>
    </ModalFormRow>
  </div>
)

export default ServicesSelector



// WEBPACK FOOTER //
// ./src/components/forms/services-selector.js